var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"head",on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"widget"},[_vm._v(_vm._s(_vm.mark))]),_vm._t("header")],2),_c('transition',{attrs:{"name":"grow"}},[(_vm.open)?_c('div',[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }